module.exports = global["XRegExp"] = require("-!/data/jenkins_data/workspace/Printos_skyline-start_master/node_modules/xregexp/src/index.js");


//////////////////
// WEBPACK FOOTER
// ../~/expose-loader?XRegExp!../~/xregexp/src/index.js
// module id = 145
// module chunks = 1